// # #############################################
// # Title : Bar Chart
// # Authors : Sameer, Mahesh, Rohit
// # Date : 15th October 2019
// # Last Modified : July 2019
// # Version : 19.10.03
// # Description : Code to display a barchart
// # ############################################

// Import required Libraries

import React, { Component } from "react";
import Highcharts from "highcharts";
// import CircularProgress from "@material-ui/core/CircularProgress";
import { abbreviateNumber } from "../utils/helperFunction";

class BarChart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [] // default data
        };
    }

    componentDidMount() {
        const seriesData = [{ name: "data", data: [] }];
        let data;
        if (this.props.data !== undefined) {
            data = this.props.data.slice(1);

            data.forEach(d => {
                d[0] = parseInt(d[0])
            })

        }

        if (data) {
            for (let i = 0; i < data.length; i++) {
                seriesData[0].data.push(data[i]);
            }
            this.loadBarChart(seriesData);
        }


    }

    componentDidUpdate() {
        // Format the data coming from props into the required format

        const seriesData = [{ name: "data", data: [] }];
        let data

        if (this.props.data !== undefined) {

            data = this.props.data.slice(1);

            data.forEach(d => {
                d[0] = parseInt(d[0])
            })
        }

        if (data) {
            for (let i = 0; i < data.length; i++) {
                seriesData[0].data.push(data[i]);
            }
            this.loadBarChart(seriesData);
        }


    }

    loadBarChart(data) {
        // Load only if there is data
        if (data.length > 0) {

            Highcharts.chart(this.refs.BarChart, {
                chart: {
                    type: "column",
                    height: "50%",
                    backgroundColor: "whitesmoke"
                },
                colors: [`${this.props.color}`],
                title: {
                    text: `${this.props.title}`
                },
                xAxis: {
                    categories: [],
                    title: {
                        text: `${this.props.xAxis}`
                    }
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: "No of instances"
                    }
                },
                credits: {
                    enabled: false
                },
                tooltip: {
                    // Tooltip Options
                    enabled: true,
                    formatter: function () {
                        return '<b>Instances</b>: ' + abbreviateNumber(this.y);
                    }
                },
                legend: {
                    enabled: false
                },
                plotOptions: {
                    column: {
                        animation: false,
                        borderWidth: 0
                    },
                    series: {
                        groupPadding: 0
                    }
                },
                series: data
            });
        }
    }

    render() {
        // Show bar chart if there is data
        if (this.props.data) {
            if (this.props.data.length > 0) {
                return <div style={{ paddingTop: "0px" }} ref="BarChart" />;
            }

            // If there is no data and simulation is started
            else if (sessionStorage.getItem("simStarted") === "true") {
                return (
                    <div className="graphLoader">
                        <div id={"loaderContainerGraphs"}>
                            <div class="lds-facebook-graphs"><div></div><div></div><div></div></div>
                        </div>
                    </div>
                );
            }

            // If simulation hasn't started, show the following text
            else {
                return (
                    <div className="noSimText">
                        Start simulation in order to view results
                    </div>
                );
            }
        } else {
            return null
        }
    }
}

export default BarChart;
